import React from 'react'
import { Box, Image } from '@mantine/core'
import InviteForm from './components/InviteForm'

export default function Invite() {
  return (
    <div className={'max-w-xl m-auto'}>
      <Box className="bg-[#5087EB] pb-4 h-screen">
        <Image src="./query_bg.png" />
        <div className="mx-4 bg-white rounded-3xl px-6 py-5 mb-4">
          <InviteForm />
        </div>
      </Box>
    </div>
  )
}
